import X from "@/src/sb/components/icon/X"
import classNames from "classnames"
import React, { ReactNode, useEffect } from "react"

type ModalProps = {
  children: ReactNode
  onClose?: () => void
  className?: string
}

const Modal = ({ children, onClose, className = "" }: ModalProps) => {
  // TODO: Implement "click outside" to close modal
  useEffect(() => {
    const body = document.querySelector("body")
    if (body?.style) {
      body.style.overflow = "hidden"
    }

    return () => {
      if (body?.style) {
        body.style.overflow = "auto"
      }
    }
  })

  return (
    <section className="flex justify-center items-center h-screen p-2 bg-stears_black/75 fixed top-0 left-0 w-full z-50">
      <div className={classNames("bg-white p-4 h-auto sticky", className)}>
        <div className="text-right">
          {onClose ? (
            <button
              className="bg-gray-200 w-7 h-7 inline-flex justify-center items-center leading-none dark:bg-gray-600"
              onClick={onClose}
            >
              <X size={20} />
            </button>
          ) : null}
        </div>
        <main className="py-4 px-4 -mx-4 max-h-[calc(100vh-128px)] overflow-auto">
          {children}
        </main>
      </div>
    </section>
  )
}

export default Modal
